import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { authAPI } from '../services/api';
import LockResetIcon from '@mui/icons-material/LockReset';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import CloseIcon from '@mui/icons-material/Close';
import './Modal.css';

function ChangePasswordModal({ onClose }) {
  const [form, setForm] = useState({ currentPassword: '', newPassword: '', confirmPassword: '' });
  const [show, setShow] = useState({ current: false, new: false, confirm: false });
  const [loading, setLoading] = useState(false);

  const toggle = (field) => setShow((prev) => ({ ...prev, [field]: !prev[field] }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.newPassword !== form.confirmPassword) {
      return toast.error('New passwords do not match');
    }
    setLoading(true);
    try {
      await authAPI.changePassword({ currentPassword: form.currentPassword, newPassword: form.newPassword });
      toast.success('Password changed successfully');
      onClose();
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to change password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-box">
        <div className="modal-box-header">
          <div className="modal-box-title">
            <LockResetIcon className="modal-title-icon" />
            <span>Change Password</span>
          </div>
          <button className="icon-btn" onClick={onClose}><CloseIcon /></button>
        </div>
        <form onSubmit={handleSubmit} className="modal-box-body">
          {[
            { label: 'Current Password', key: 'currentPassword', showKey: 'current' },
            { label: 'New Password', key: 'newPassword', showKey: 'new' },
            { label: 'Confirm New Password', key: 'confirmPassword', showKey: 'confirm' },
          ].map(({ label, key, showKey }) => (
            <div className="form-group" key={key}>
              <label>{label}</label>
              <div className="input-with-icon">
                <input
                  type={show[showKey] ? 'text' : 'password'}
                  value={form[key]}
                  onChange={(e) => setForm({ ...form, [key]: e.target.value })}
                  placeholder={label}
                  required
                />
                <button type="button" className="input-icon-btn" onClick={() => toggle(showKey)}>
                  {show[showKey] ? <VisibilityOffIcon fontSize="small" /> : <VisibilityIcon fontSize="small" />}
                </button>
              </div>
            </div>
          ))}
          <div className="modal-box-actions">
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'Saving...' : 'Update Password'}
            </button>
            <button type="button" className="btn btn-secondary" onClick={onClose}>Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ChangePasswordModal;
